import React from "react";
import ManageProfileTabContent from "./ManageProfileTabContent";

export const ManageProfileTabContentView = () => {
  return (
    <div
      style={{
        padding: "2rem",
        width:"100%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <ManageProfileTabContent />
    </div>
  );
};
